import { useEffect, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
//redux
import { useDispatch } from "react-redux";
import { getPaxQuestions } from "_redux/slices/analytics/review-control-panel";
import { getAirportLogo } from "_redux/slices/analytics/reviews";
//booststrap
import { Container, Col, Row, Button } from "react-bootstrap";
//custom component
import FlightDetails from "./flight-details";
import SurveyQuestions from "./survey-questions";
import SurveyCompleted from "./survey-conclusion";
import { PRM_LIGHT_BLUE } from "_styles/colors";


const InitialScreen = ({ setStep }) => {
    const title = "Passenger survey";
    const subTitle = ` This survey should take you an estimated 3 mins to complete and will help all airports improve the service going forward.`
    const startBtn = "Start Survey";

    return (
        <>
            <Container style={{ textAlign: "center" }}>
                <Row className="p-3">
                    <Col xs={12}>
                        <p style={{ fontSize: 24, color: PRM_LIGHT_BLUE, opacity: 0.8 }}>
                            {title}
                        </p>
                        <p style={{ fontSize: 18, marginTop: "20px" }}>
                            {subTitle}
                        </p>
                    </Col>
                </Row>
            </Container>


            <Container style={{ textAlign: "center" }}>
                <Row>
                    <Col xs={12} style={{ marginBottom: "20px" }}>
                        <Button variant="primary" onClick={() => setStep("flight")} style={{ width: "100%" }} >
                            {startBtn}
                        </Button>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

const AirportSurvey = () => {

    const { surveyId, airport } = useParams();
    const dispatch = useDispatch();

    const [viewportHeight, setViewportHeight] = useState(window.innerHeight);               // window height
    const [step, setStep] = useState("initial");                                            //steps are: initial,questions,conclusin

    //#region useEffect 
    useEffect(() => {
        const handleResize = () => {
            setViewportHeight(window.innerHeight);
        };
        // Set initial height
        handleResize();
        // Update height on resize
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        if (airport) {
            dispatch(getPaxQuestions({
                surveyId,
                language: "en"
            }));
            dispatch(getAirportLogo(airport));
        }
    }, [airport]);


    //#endregion

    const handleCurrentScreen = () => {
        if (step === "initial") return <InitialScreen setStep={setStep} />
        if (step === "flight") return <FlightDetails setStep={setStep} />
        if (step === "questions") return <SurveyQuestions setStep={setStep} iata={airport} />
        return <SurveyCompleted />
    }

    return (
        <Container style={{ height: `${viewportHeight}px`, display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
            {handleCurrentScreen()}
        </Container>
    )
}
export default AirportSurvey